import React from 'react';
import './president.scss';
import { Row, Col, Button } from 'react-bootstrap';

import alex from '../../../images/alex2.png';

class President extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      presidentReadMore: false
    };

    this.readMorePresident = this.readMorePresident.bind(this);
  }


  readMorePresident() {
    this.setState({ presidentReadMore: true });
  }


  getPresidentName() {
    const names = {
      ka: 'ალექსი მახარაშვილი',
      en: 'Aleksiy Makharashvili',
      ru: 'Алексий Махарашвили'
    };

    return names[this.props.commonProps.lang];
  }


  getReadMore() {
    const readMores = {
      ka: 'სრულად',
      en: 'Read More',
      ru: 'Подробнее'
    };

    return readMores[this.props.commonProps.lang];
  }


  getTitle() {
    const titles = {
      ka: 'პრეზიდენტის მიმართვა',
      en: 'Message from the President',
      ru: 'Обращение Президента'
    };

    return titles[this.props.commonProps.lang];
  }


  getBody() {
    const bodies = {
      ka: (<div className="bodyFont text">
            ძვირფასო კოლეგებო!
            <br />
            მაქვს პატივი მოგიწვიოთ საქართველოს თმის აღდგენის საზოგადოების პირველ საერთაშორისო კონგრესზე.
            <br />
            თმის ცვენა დღესდღეობით ერთ-ერთი ყველაზე გავრცელებული პრობლემაა, რომელიც დედამიწის მოსახლეობის ნახევარზე მეტს აწუხებს. დღეისათვის არსებული ტექნიკური პროგრესი და ჩვენი ცხოვრების თავბრუდამხვევი რიტმი ხელს უწყობს ამ პრობლემის გაღრმავებასა და გაახალგაზრდავებას. ჩვენ ვცხოვრობთ ყოველდღიური სტრესისა და გარემოს მავნებლური ზემოქმედების პირობებში, რაც უარყოფითად აისახება ჩვენს ჯანმრთელობაზე ეს კი ხშირად თმის სხვადასხვა პათოლოგიის გამომწვევი მიზეზი ხდება.
            <br />
            საქართველოს თმის აღდგენის საზოგადოების პირველი საერთაშორისო კონგრესის მიზანია შეკრიბოს როგორც საქართველოში, ასევე უცხოეთში მოღვაწე სპეციალისტები, რათა მოხდეს გამოცდილების გაზიარება. ჩვენ საშუალება გვექნება ვიმსჯელოთ სწორედ იმ პრობლემურ საკითხებზე, რომლებიც ტრიქოლოგიასა და თმის აუტოტრანსპლანტაციაში გვხვდება. ერთად დავსახოთ მათი გადაჭრის გზები!
            <br />
            GSHR-ის კარი ღიაა ჩვენი თითოეული კოლეგისთვის. საზოგადოებაში გაწევრიანება გარდა დერმატოლოგებისა და ქირურგებისა, შეუძლია ნებისმიერ ექიმს, რადგან თმა არ განიხილება ცალკე, განყენებულ ორგანოდ. ის ჩვენი, ერთი მთლიანი ორგანიზმის განუყოფელი ნაწილია და მასზე მნიშვნელოვან გავლენას ახდენს სხვა ორგანოთა სისტემებში მიმდინარე პროცესები.
            <br />
            { this.state.presidentReadMore ? '' : <Button variant="outline-primary readMore" onClick={this.readMorePresident}>{ this.getReadMore() }</Button> }
            {
              this.state.presidentReadMore ?
              <div>
                GSHR-ის პირველი საერთაშორისო კონგრესის მონაწილეებს საშუალება მიეცემათ საწევრო გადასახადის გარეშე გაწევრიანდნენ საზოგადოებაში. იმედი მაქვს, რომ სამეცნიერო მნიშვნელობისა და იმ წვლილის გარდა, რომელსაც კონგრესი შეიტანს დარგის განვითარების საქმეში, თქვენი კოლეგებთან მეგობრულ გარემოში გატარებული დღეები იქნება დაუვიწყარი შთაბეჭდილებებით აღსავსე.
                <br />
                19 ოქტომბერს კონგრესის დასრულების შემდგომ გაიმართება გალა ვახშამი, სადაც საშუალება მოგეცემათ დააგემოვნოთ ტრადიციული ქართული კერძები და გაითავისოთ ეროვნული ფოლკლორის თავისებურებანი. 20 ოქტომბერს მსურველთათვის მოეწყობა ექსკურსია საქართველოს ერთ-ერთ ულამაზეს კუთხეში – კახეთში. თქვენ გელით კიდევ მრავალი სასიამოვნო სიურპრიზი.
                <br />
                გელოდებით 19-20 ოქტომბერს თბილისში, საქართველოს თმის აღდგენის საზოგადოების პირველ საერთაშორისო კონგრესზე.
              </div> : ''
            }
          </div>),
      en: (<div className="bodyFont text">
            Dear Colleagues!
            <br />
            I have the honor to invite you to the First International Congress of the Georgian Hair Restoration Society.
            <br />
            Hair loss is one of the most common problems nowadays, affecting more than half of the earth's population. The current technical progress and the uplifting rhythm of our lives help to deepen and rejuvenate this problem. We live in conditions of daily stress and harmful effects on the environment, which can adversely affect our health, which is often the cause of various hair pathologies..
            <br />
            The goal of the first International Congress of the Hair Restoration Society of Georgia is to bring together professionals working both in Georgia and abroad to share experiences. We will be able to discuss precisely the issues that arise in trichology and hair transplantation. Let's figure out ways to solve them together!
            <br />
            The GSHR door is open to each of our colleagues. Anyone other than dermatologists and surgeons can join the community, as any hair is not considered a separate body. It is an integral part of our whole organism, and is greatly influenced by processes in other organ systems.
            <br />
            { this.state.presidentReadMore ? '' : <Button variant="outline-primary readMore" onClick={this.readMorePresident}>{ this.getReadMore() }</Button> }
            {
              this.state.presidentReadMore ?
              <div>
                GSHR First International Congress participants will be able to join the community without membership fees. I hope that besides the scientific importance and contribution that Congress will make to the development of the field, the days spent in a friendly environment with your colleagues will be unforgettable..
                <br />
                On October 19, after the end of the Congress, a gala dinner will be held where you will be able to taste traditional Georgian dishes and get acquainted with the features of national folklore. On October 20, an excursion will be held in one of the most beautiful parts of Georgia - Kakheti. You will have many more pleasant surprises.
                <br />
                We are waiting for you on October 19-20 at the First International Congress of Georgian Hair Restoration Society in Tbilisi.
              </div> : ''
            }
          </div>),
      ru: (<div className="bodyFont text">
            Уважаемые коллеги!
            <br />
            Имею честь пригласить Вас на первый Международный конгресс «Грузинского общества восстановления волос», который состоится в Тбилиси, столице небольшой европейской страны. История Тбилиси насчитывает 16 веков и отличается своей красотой и гостеприимным населением.
            <br />
            В настоящее время выпадение волос является одной из наиболее распространенных проблем, затрагивающих более половины населения Земного шара. Текущий технический прогресс и головокружительный ритм нашей жизни способствуют углубить и омолодить эту проблему. Мы живем в условиях ежедневного стресса и вредного воздействия окружающей среды, что отрицательно сказываеться на нашем здоровье и часто является причиной различных патологий волос.
            <br />
            Целью первого Международного конгресса «Грузинского общества восстановления волос» является объединение специалистов, работающих как в Грузии, так и за рубежом для обмена опытом. У нас будет возможность обсудить проблемные вопросы, которые встречаются в трихологии и аутотрансплантации волос. Давайте найдем способы решить их вместе!
            <br />
            Двери GSHR открыты для каждого из наших коллег. Любой врач может присоединиться к обществу, поскольку волосы не рассматриваются отдельно, отдельным органом. Это неотъемлемая часть всего нашего организма, и на нее сильно влияют процессы, происходящие в других органах и системах.
            <br />
            { this.state.presidentReadMore ? '' : <Button variant="outline-primary readMore" onClick={this.readMorePresident}>{ this.getReadMore() }</Button> }
            {
              this.state.presidentReadMore ?
              <div>
                Участники Первого международного конгресса GSHR смогут вступить в общества без членского взноса. Я надеюсь, что помимо научной значимости и вклада, который Конгресс внесет в развитии отрасли, дни, проведенные в дружеской обстановке с вашими коллегами, будут незабываемыми. 19 октября, после окончания Конгресса, состоится гала-ужин, где вы сможете продегустировать традиционные грузинские блюда и ознакомиться с особенностями национального фольклора. 20 октября, для желающих, состоится экскурсия в один из самых красивых уголков Грузии - Кахетии, где вы ознакомитесь с традицией грузинского виноделия, узнаете, как производится грузинская чача, и своими руками сможете сделать грузинские сладости - Чурчхела. Вас ждет еще много приятных сюрпризов.
                <br />
                Ждем Вас 19-20 октября 2019 года в Тбилиси, на первом международном конгрессе «Грузинского общества восстановления волос».
              </div> : ''
            }
          </div>)
    };

    return bodies[this.props.commonProps.lang];
  }


  render() {
    return (
      <div className="component president">
        <div className="content">
          <h4 className="title capsFont">{ this.getTitle() }</h4>
          <div className="body">
            <Row>
              <Col md={4} style={{ textAlign: 'center' }}>
                <img src={alex} alt="president" />
                <h5 className="president_name capsFont">{ this.getPresidentName() }</h5>
              </Col>
              <Col md={8}>
                { this.getBody() }
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }

}

export default President;
